(() => {
  const init = () => {
    document.querySelectorAll('[data-fph-range]').forEach(range => {
      if (range.dataset.fphReady) return;
      const filters = range.querySelector('[data-fph-filters]');
      const choices = range.querySelector('[data-fph-choices]');
      const cards = [...range.querySelectorAll('[data-fph-model]')];
      const status = range.querySelector('[data-fph-status]');
      if (!filters || !choices || !cards.length || !status) return;
      const buttons = [...filters.querySelectorAll('[data-fph-filter]')];
      const selectLayout = (card, button) => {
        const template = [...card.querySelectorAll('template[data-fph-layout-template]')]
          .find(item => item.dataset.fphLayoutTemplate === button.dataset.fphLayout);
        if (!template) return;
        const content = template.content.cloneNode(true);
        const imageView = card.querySelector('[data-fph-image-view]');
        const copyView = card.querySelector('[data-fph-copy-view]');
        if (imageView && copyView) {
          imageView.replaceChildren(content.querySelector('.fph-card-image'));
          copyView.replaceChildren(content.querySelector('.fph-card-copy'));
        } else {
          card.querySelector('[data-fph-layout-view]').replaceChildren(content);
        }
        card.querySelectorAll('[data-fph-layout]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      };
      cards.forEach(card => {
        const group = card.querySelector('[data-fph-layout-choices]');
        group.hidden = false;
        group.addEventListener('click', event => {
          const button = event.target.closest('button[data-fph-layout]');
          if (button && group.contains(button)) selectLayout(card, button);
        });
      });
      range.dataset.fphReady = 'true';
      choices.hidden = false;
      buttons.forEach(button => { button.hidden = false; });
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-fph-filter]');
        if (!button || !buttons.includes(button)) return;
        const value = button.dataset.fphFilter;
        let count = 0;
        cards.forEach(card => {
          const layouts = [...card.querySelectorAll('button[data-fph-layout]')];
          const matches = layouts.filter(item => value === 'all' || item.dataset.fphLayoutUse.split(/\s+/).includes(value));
          card.hidden = matches.length === 0;
          layouts.forEach(item => { item.hidden = !matches.includes(item); });
          if (!matches.length) return;
          count += 1;
          if (!matches.some(item => item.getAttribute('aria-pressed') === 'true')) selectLayout(card, matches[0]);
        });
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        const label = button.querySelector('[data-fph-filter-label]').textContent.trim();
        status.textContent = status.dataset.statusTemplate.replace('[count]', String(count)).replace('[purpose]', label);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
